module.exports = __webpack_public_path__ + "media/images/athletes/3597-537c67570bcf62317a1f477e686f8a0c.png";